// extracted by mini-css-extract-plugin
export default {"description":"BulkCommentPanel_description__X0zt6"};